import axios from './BaseService';

const MESSAGE_TEMPLATES_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/message-templates/`;

export async function getMessageTemplates() {
    const response = await axios.get(MESSAGE_TEMPLATES_URL);
    return response.data;
}

export async function getMessageTemplate(id) {
    const response = await axios.get(`${MESSAGE_TEMPLATES_URL}${id}`);
    return response.data;
}

export async function createMessageTemplate(messageTemplate) {
    const response = await axios.post(MESSAGE_TEMPLATES_URL, messageTemplate);
    return response.data;
}

export async function updateMessageTemplate(id, messageTemplate) {
    const response = await axios.put(`${MESSAGE_TEMPLATES_URL}${id}`, messageTemplate);
    return response.data;
}

export async function deleteMessageTemplate(id) {
    const response = await axios.delete(`${MESSAGE_TEMPLATES_URL}${id}`);
    return response.data;
}



